export enum PermissionTypes {
  SET_CONTROLS = "SET_CONTROLS",
}
